import * as zod from 'zod';

export const TOKEN_NAME_MAX_LENGTH = 255;

export const VALID_TOKEN_SOURCES = [
  'user',
  'ios_teleop',
  'ipad_teleop',
  'code_block',
] as const;

export type TokenSource = (typeof VALID_TOKEN_SOURCES)[number];

export const DevTokensData = zod.object({
  id: zod.string(),
  prefix: zod.string(),
  name: zod.string().max(TOKEN_NAME_MAX_LENGTH),
  token: zod.string().optional(),
  token_hash: zod.string().optional(),
  created: zod.string().optional(),
  expires_at: zod.string().nullable().optional(),
  source: zod.string().nullable().optional(),
  ephemeral: zod.boolean().optional(),
});

export type DevTokensData = zod.infer<typeof DevTokensData>;
